import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[appScrollToTop]'
})
export class ScrollToTopDirective implements AfterViewInit {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    // Chỉ tạo nút khi chạy ở client-side (trình duyệt)
    if (typeof window !== 'undefined') {
      this.createScrollButton();
    }
  }

  private createScrollButton() {
    const button = this.renderer.createElement('button');
    this.renderer.setStyle(button, 'position', 'fixed');
    this.renderer.setStyle(button, 'bottom', '20px');
    this.renderer.setStyle(button, 'right', '20px');
    this.renderer.setStyle(button, 'width', '35px');
    this.renderer.setStyle(button, 'height', '35px');
    this.renderer.setStyle(button, 'border-radius', '5px');
    this.renderer.setStyle(button, 'background-color', '#ebab34');
    this.renderer.setStyle(button, 'color', 'white');
    this.renderer.setStyle(button, 'border', 'none');
    this.renderer.setStyle(button, 'font-size', '18px');
    this.renderer.setStyle(button, 'display', 'flex');
    this.renderer.setStyle(button, 'justify-content', 'center');
    this.renderer.setStyle(button, 'align-items', 'center');
    this.renderer.setStyle(button, 'cursor', 'pointer');
    this.renderer.setStyle(button, 'z-index', '1000');
    this.renderer.setStyle(button, 'padding-bottom', '6px');
    this.renderer.setProperty(button, 'innerHTML', '↑');

    this.renderer.listen(button, 'click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    this.renderer.appendChild(this.el.nativeElement, button);
  }

}
